module.exports = __webpack_public_path__ + "img/1-知识.07f3e397.gif";